import { Box, Paper, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { shallowEqual, useSelector } from "react-redux";
import { IInput } from "../../entities/certificates";
import { getExpectedCsvColumnName, getMissingFields, normalizeCsvColumnKey, normalizeCsvDataKeys, sanitizeData, validatedColumns } from "../../lib/parser";
import LoadCsv from "../LoadCsv";
import Table from "./Table";
import { MAPPING_METADATA_KEYS_TO_LABEL } from "../../lib/referentiel";
import { IState } from "../../lib/store";
interface IProps {
    mandatory: {
        columns: string[];
        header: string[];
    };
    setInputs: (inputs: IInput[]) => void;
}

const getHeaderLabel = (column: string): string => 
    MAPPING_METADATA_KEYS_TO_LABEL[column] || column;

const Component: React.FC<IProps> = ({mandatory, setInputs}) => {
    const organizationName = useSelector((state: IState) => state.organization.organization?.name, shallowEqual);
    const [columns, setColumns] = useState<string[]>();
    const [rows, setRows] = useState<Record<string, string>[]>();
    const [corruptedRows, setCorruptedRows] = useState<Record<string, string>[]>();

    const setCsvData = (data: Record<string, string>[]) => {
        // Colonnes = header du CSV normalisé (sans effets de sanitizeData)
        const headerColumns = Object.keys(data[0]).map(normalizeCsvColumnKey);
        setColumns(headerColumns);

        const rows: Record<string, string>[] = data
            .map(normalizeCsvDataKeys)
            .map((row) => sanitizeData(row, { organizationName }));

        setCorruptedRows(rows.filter((r) => r['wrong_date_naiss'] === 'true'));
        setRows(rows);
    }

    useEffect(() => {
        if (corruptedRows && corruptedRows.length > 0) {
            setInputs([]);
        } else {
            setInputs(rows!);
        }
    }, [rows]);

    const mandatoryHeaders = mandatory.columns.map(getHeaderLabel);

    return columns ?

        (
            validatedColumns(mandatory.columns, columns) ? 
                (
                    corruptedRows && corruptedRows.length > 0 ? (
                        <Box display="flex" flexDirection="column" gap={3}>
                            <Box component={Paper} p={2}>
                                <Typography color="error">Les dates de naissances dans le tableau suivant sont au mauvais format, veuillez corriger dans le csv.</Typography>
                            </Box>
                            <Table header={mandatoryHeaders} columns={mandatory.columns!}  rows={corruptedRows!}/>
                            <Box><LoadCsv setCsvData={setCsvData} /></Box>          
                        </Box>
                    ) : <Table header={mandatoryHeaders} columns={mandatory.columns!}  rows={rows!}/>
                ) : 
                (
                    <Box display="flex" flexDirection="column" gap={3}>
                        <Box component={Paper} p={2}>
                            <Typography>Veuillez ajouter les champs obligatoires suivants au fichier CSV:</Typography>
                            <Typography variant="caption" color="text.secondary" sx={{display: 'block', mt: 1}}>
                                Les noms des colonnes doivent correspondre exactement aux noms CSV du template (ex: date_de_naissance, session, programme) et les valeurs ne doivent pas etre vides.
                            </Typography>
                        <div style={{color: 'red'}}>{getMissingFields(mandatory.columns, columns).map((f: string, idx: number) => <span key={idx} style={{display: 'block'}}>{getHeaderLabel(f)}: {getExpectedCsvColumnName(f)}</span>)}</div>
                        </Box>
                        <Box><LoadCsv setCsvData={setCsvData} /></Box>          
                    </Box>
                )
        )
        : (
            <div style={{height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                <LoadCsv setCsvData={setCsvData} />
            </div>
        )
}

export default Component;